angular.module('tf.services')

    .service('BillingService', ['$rootScope','HttpService','$q','BillingSource', 'BillingInvoice', 'Session',
        function ($rootScope, HttpService, $q, BillingSource, BillingInvoice, Session) {

        this.loadSources = function () {
            var defer =$q.defer();
            HttpService.get('billing/sources').then(function(res){
                var sources = res.data.sources.map(function(source){
                    return new BillingSource(source);
                });
                defer.resolve(sources);
            },defer.reject);
            return defer.promise;
        };

        this.loadInvoices = function () {
            var defer =$q.defer();
            HttpService.get('billing/invoices').then(function(res){
                var invoices = res.data.invoices.map(function(source){
                    return new BillingInvoice(source);
                });
                var upcomingInvoice = {};
                if(res.data.upcomingInvoice){
                    upcomingInvoice  = new BillingInvoice(res.data.upcomingInvoice);
                }
                defer.resolve({invoices: invoices,upcomingInvoice: upcomingInvoice});
            },defer.reject);
            return defer.promise;
        };

        this.setAsDefault = function(source){
            var defer =$q.defer();
            HttpService.post('billing/default',{source:source}).then(function(res){
                var sources = res.data.sources.map(function(source){
                    return new BillingSource(source);
                });
                defer.resolve(sources);
            },defer.reject);
            return defer.promise;
        };

        this.removeSource = function(source){
            var defer =$q.defer();
            HttpService.post('billing/delete',{source:source}).then(function(res){
                var sources = res.data.sources.map(function(source){
                    return new BillingSource(source);
                });
                defer.resolve(sources);
            },defer.reject);
            return defer.promise;
        };

        this.plans = {
            basic: {
                m: 700,
                y: 7500
            },
            pro: {
                m: 1500,
                y: 15000
            },
            payg: {
                content: 1.5
            },
            commitment:[{
                renders:0,
                price_per_render : 1.5,
                price:0,
            },{
                renders:150,
                price_per_render : 1.3,
                price:195,
            },{
                renders:300,
                price_per_render : 1.2,
                price:360,
            },{
                renders:600,
                price_per_render : 1.1,
                price:660,
            },{
                renders:1200,
                price_per_render : 1,
                price:1200
            }]
        };

        this.planSummery = function(){
            var plan = Session.farm.plan;
            if(plan && plan.commitment !== undefined){
                var summery = {
                    current : _.find(this.plans.commitment, {renders : plan.commitment}),
                    next : plan.next? _.find(this.plans.commitment, {renders : plan.next.commitment}) : null
                };
                if(plan.next && summery.next) summery.next.start_time = moment(plan.next.start_time).format('ll');
                return summery;
            }
        };

        return this;
    }])
;
